import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Footer from './components/Footer';
import SkyCycle from './components/SkyCycle';
import ScrollToTop from './utils/ScrollToTop';
import HomePage from './pages/HomePage';
import ConceptPage from './pages/ConceptPage';
import CommentCaMarchePage from './pages/CommentCaMarchePage';
import PourquoiSunSpotPage from './pages/PourquoiSunSpotPage';
import PhilosophiePage from './pages/PhilosophiePage';
import FaqPage from './pages/FaqPage';
import BlogHomePage from './pages/blog/BlogHomePage';
import SpotArticlePage from './pages/blog/SpotArticlePage';
import { trackNavigation, trackDeviceInfo, trackAnimationInteraction } from './utils/analytics';
import './App.css';

// Composant pour tracker les changements de route
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track navigation pour chaque changement de route
    const pageName = location.pathname === '/' ? 'home' : 
                    location.pathname.replace('/', '').replace('-', '_');
    trackNavigation(pageName, document.referrer);
  }, [location]);

  return null;
};

// Composant principal App
function App() {
  useEffect(() => {
    // Tracking initial de l'application
    trackDeviceInfo();
    
    // Tracking de l'animation SkyCycle au démarrage
    const animationTimer = setTimeout(() => {
      trackAnimationInteraction('skycycle_animation_completed', 'time_cycle_intro');
    }, 7000); // Après 7 secondes (6s animation + 1s)

    return () => clearTimeout(animationTimer);
  }, []);

  return (
    <Router>
      <div className="App">
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        
        <div className="relative min-h-screen">
          {/* SkyCycle Background - Stops exactly after stats cards */}
          <SkyCycle height="110vh" fastForwardMs={6000} />
          
          {/* Content overlay without blur effect */}
          <div className="absolute inset-0 z-10">
            {/* Main content */}
            <div className="relative z-20">
              <Header />
              <main>
                <ScrollToTop />
                <RouteTracker />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/concept" element={<ConceptPage />} />
                  <Route path="/comment-ca-marche" element={<CommentCaMarchePage />} />
                  <Route path="/pourquoi-sun-spot" element={<PourquoiSunSpotPage />} />
                  <Route path="/philosophie" element={<PhilosophiePage />} />
                  <Route path="/faq" element={<FaqPage />} />
                  <Route path="/blog" element={<BlogHomePage />} />
                  <Route path="/blog/spots/:slug" element={<SpotArticlePage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;